var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({
    background: _vm.whiteBackground
      ? _vm.$vuetify.theme.themes[_vm.theme].backgroundWhite
      : _vm.$vuetify.theme.themes[_vm.theme].background,
  }),attrs:{"id":"app"}},[_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"}}),_c('div',[_c('v-main',[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }